'use strict';

import { cn_zoning_type } from '../extension/cn_zoning_type';
import { cn_element } from './cn_element';
//***********************************************************************************
//***********************************************************************************
//******     CN-Map    **************************************************************
//******     Copyright(C) 2019-2020 EnerBIM                        ******************
//***********************************************************************************
//***********************************************************************************
//***********************************************************************************
//***********************************************************************************
//**** Zone
//***********************************************************************************
//***********************************************************************************

export const ZONE_EXTERIOR_LABEL = 'Extérieur';

export class cn_zone extends cn_element {
    //*******************************************************
    /**
     * Constructor
     */
    constructor(name = '', main_storey = '', zone_type = '', space_auto_numerotation_idx = 0) {
        super();
        this.class_name = 'cn_zone';
        this.name = name;
        this.zone_type = zone_type;
        this.main_storey = main_storey;
        this.color = '';
        /**
         * Spaces and storeys ids
         * @type {{space: string, storey: string}[]}
         */
        this.rooms = [];
    }

    /**
     * Returns the list of zoning types
     * @returns {Array<string>}
     */
    static get_zoning_types() {
        return cn_zoning_type.get_zoning_types().map(zt => zt.property);
    }

    /**
     * Duplicate zone object without rooms and color for new storey
     *
     * @param {cn_zone} zone
     * @param {string} new_storey_id
     * @returns
     */
    static duplicate_for_new_storey(zone, new_storey_id) {
        const result = new cn_zone();
        result.name = zone.name;
        result.zone_type = zone.zone_type;
        result.main_storey = new_storey_id;
        return result;

    }

    //*******************************************************
    /**
     * serialize
     * @returns {object} json object
     */
    serialize() {
        return this.serialize_with_building(null);
    }

    serialize_with_building(building) {
        const json = this.serialize_element();
        json.name = this.name;
        if (building)
            json.main_storey = this.main_storey;
        json.zone_type = this.zone_type;
        if (building)
            json.rooms = [...this.rooms];
        json.color = this.color;
        return json;
    }
    //*******************************************************
    /**
     * unserialize
     * @returns {object} zone object
     */
    static unserialize(json, building = null) {
        const result = new cn_zone(json.name);
        result.unserialize_element(json);
        result.name = json.name;
        if (building && json.main_storey)
            result.main_storey = json.main_storey;
        result.zone_type = json.zone_type || '';
        if (building && json.rooms)
            result.rooms = [...json.rooms];
        result.color = json.color;
        if (building)
            result.check(building);
        return result;
    }

    /**
     * Add room to zone
     *
     * @param {string} space_id
     * @param {string} storey_id
     */
    add_room(space_id, storey_id) {
        if (this.rooms.findIndex(it => it.space === space_id && it.storey === storey_id) < 0) {
            this.rooms.push({ space: space_id, storey: storey_id });
        }
    }

    /**
     * Remove room from zone
     *
     * @param {string} space_id
     * @param {string} storey_id
     */
    remove_room(space_id, storey_id) {
        const index = this.rooms.findIndex(room => room.space === space_id && room.storey === storey_id);
        if (index >= 0) {
            this.rooms.splice(index, 1);
        }
    }

    check(building, transaction_manager = null) {
        if (transaction_manager)
            transaction_manager.push_item_set(this, ["rooms", "main_storey"]);

        this.rooms = this.rooms.filter(room => {
            const storey = building.storeys.find(storey => storey.ID == room.storey);
            if (storey && storey.scene.spaces.find(space => space.ID == room.space))
                return true;
            return false;
        });
        if (!building.storeys.find(storey => storey.ID == this.main_storey)) {
            if (this.rooms.length)
                this.main_storey = building.storeys.find(storey => storey.ID == this.rooms[0].storey).ID;
            else
                this.main_storey = building.storeys[0].ID;
        }
    }
}
